import { Component } from "preact";
import * as echarts from 'echarts';

interface VisitsChartProps {
    data: { day: string; visits: number }[];
}

class VisitsChart extends Component<VisitsChartProps> {
    chart: echarts.EChartsType | null = null;

    override componentDidMount() {
        this.chart = echarts.init(document.getElementById("visits-chart")!);
        this.updateChart();
    }

    override componentDidUpdate(previousProps: VisitsChartProps) {
        if (previousProps.data !== this.props.data) {
            this.updateChart();
        }
    }

    updateChart() {
        if (!this.chart || !this.props.data) return;

        const visitsData = this.props.data.map((session: any) => ({
            name: session.day,
            value: [new Date(session.day).getTime(), session.visits]
        }));

        this.chart.setOption({
            backgroundColor: 'transparent',
            grid: {
                left: '3%',
                right: '3%',
                bottom: '10%',
                top: '10%',
                containLabel: true
            },
            xAxis: {
                type: 'time',
                axisLine: {
                    lineStyle: {
                        color: '#e5e7eb'
                    }
                },
                axisLabel: {
                    color: '#6b7280',
                    fontSize: 12
                },
                splitLine: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: '#6b7280',
                    fontSize: 12
                },
                splitLine: {
                    lineStyle: {
                        color: '#f3f4f6',
                        type: 'solid'
                    }
                }
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: '#1f2937',
                borderColor: '#1f2937',
                textStyle: {
                    color: '#ffffff'
                },
                formatter: function (params: any) {
                    const date = new Date(params[0].value[0]);
                    return `${date.toLocaleDateString('it-IT', { 
                        weekday: 'short', 
                        month: 'short', 
                        day: 'numeric' 
                    })}<br/><strong>${params[0].value[1]}</strong> visite`;
                }
            },
            series: [
                {
                    data: visitsData,
                    type: 'line',
                    smooth: false,
                    showSymbol: false,
                    lineStyle: {
                        color: '#5850ec',
                        width: 2
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(88, 80, 236, 0.2)' },
                            { offset: 1, color: 'rgba(88, 80, 236, 0)' }
                        ])
                    }
                }
            ]
        });
    }

    render() {
        return (
            <div id="visits-chart" className="chart-wrapper"></div>
        );
    }
}

export default VisitsChart;